import * as React from "react";

type PageHeaderProps = {
    title: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
    return (
        <div className="pattern pattern--page-header pattern--pad pattern--has-watermark bg-brand-red pattern--has-bgcolor">
            <div className="container">
                <h1 className="h1 pattern__headline">{title}</h1>
            </div>
        </div>
    );
}

export default PageHeader;